var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 55,
    viewBox: "0 0 77 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83333,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 1.83333 53.1667)",
    fill: "#E6E5E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83333,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 1.83333 45.8334)",
    fill: "#E6E5E5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83333,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 1.83333 38.5)",
    fill: "#E6E5E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83333,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 1.83333 31.1667)",
    fill: "#E6E5E5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83333,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 1.83333 23.8334)",
    fill: "#E6E5E5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83333,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 1.83333 16.5)",
    fill: "#E6E5E5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83333,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 1.83333 9.16667)",
    fill: "#E6E5E5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83333,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 1.83333 1.83335)",
    fill: "#E6E5E5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16671,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 9.16671 53.1667)",
    fill: "#E6E5E5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16683,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 9.16683 45.8334)",
    fill: "#E6E5E5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16683,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 9.16683 38.5)",
    fill: "#E6E5E5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16683,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 9.16683 31.1667)",
    fill: "#E6E5E5"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16683,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 9.16683 23.8334)",
    fill: "#E6E5E5"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16683,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 9.16683 16.5)",
    fill: "#E6E5E5"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16683,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 9.16683 9.16667)",
    fill: "#E6E5E5"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16683,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 9.16683 1.83335)",
    fill: "#E6E5E5"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 16.5 53.1667)",
    fill: "#E6E5E5"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4998,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 16.4998 45.8334)",
    fill: "#E6E5E5"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4998,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 16.4998 38.5)",
    fill: "#E6E5E5"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4998,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 16.4998 31.1667)",
    fill: "#E6E5E5"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4998,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 16.4998 23.8334)",
    fill: "#E6E5E5"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4998,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 16.4998 16.5)",
    fill: "#E6E5E5"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4998,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 16.4998 9.16667)",
    fill: "#E6E5E5"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4998,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 16.4998 1.83335)",
    fill: "#E6E5E5"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8333,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 23.8333 53.1667)",
    fill: "#E6E5E5"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8333,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 23.8333 45.8334)",
    fill: "#E6E5E5"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8333,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 23.8333 38.5)",
    fill: "#E6E5E5"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8333,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 23.8333 31.1667)",
    fill: "#E6E5E5"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8333,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 23.8333 23.8334)",
    fill: "#E6E5E5"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8333,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 23.8333 16.5)",
    fill: "#E6E5E5"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8333,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 23.8333 9.16667)",
    fill: "#E6E5E5"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8333,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 23.8333 1.83335)",
    fill: "#E6E5E5"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1667,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 31.1667 53.1667)",
    fill: "#E6E5E5"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1668,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 31.1668 45.8334)",
    fill: "#E6E5E5"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1668,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 31.1668 38.5)",
    fill: "#E6E5E5"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1668,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 31.1668 31.1667)",
    fill: "#E6E5E5"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1668,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 31.1668 23.8334)",
    fill: "#E6E5E5"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1668,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 31.1668 16.5)",
    fill: "#E6E5E5"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1668,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 31.1668 9.16667)",
    fill: "#E6E5E5"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1668,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 31.1668 1.83335)",
    fill: "#E6E5E5"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 38.5 53.1667)",
    fill: "#E6E5E5"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4998,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 38.4998 45.8334)",
    fill: "#E6E5E5"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4998,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 38.4998 38.5)",
    fill: "#5C9FFF"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4998,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 38.4998 31.1667)",
    fill: "#E6E5E5"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4998,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 38.4998 23.8334)",
    fill: "#E6E5E5"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4998,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 38.4998 16.5)",
    fill: "#E6E5E5"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4998,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 38.4998 9.16667)",
    fill: "#E6E5E5"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4998,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 38.4998 1.83335)",
    fill: "#E6E5E5"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8333,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 45.8333 53.1667)",
    fill: "#E6E5E5"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8333,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 45.8333 45.8334)",
    fill: "#E6E5E5"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8333,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 45.8333 38.5)",
    fill: "#E6E5E5"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8333,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 45.8333 31.1667)",
    fill: "#E6E5E5"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8333,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 45.8333 23.8334)",
    fill: "#E6E5E5"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8333,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 45.8333 16.5)",
    fill: "#E6E5E5"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8333,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 45.8333 9.16667)",
    fill: "#E6E5E5"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8333,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 45.8333 1.83335)",
    fill: "#E6E5E5"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1666,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 53.1666 53.1667)",
    fill: "#E6E5E5"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1666,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 53.1666 45.8334)",
    fill: "#E6E5E5"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1666,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 53.1666 38.5)",
    fill: "#E6E5E5"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1666,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 53.1666 31.1667)",
    fill: "#E6E5E5"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1666,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 53.1666 23.8334)",
    fill: "#E6E5E5"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1666,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 53.1666 16.5)",
    fill: "#E6E5E5"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1666,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 53.1666 9.16667)",
    fill: "#E6E5E5"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1666,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 53.1666 1.83335)",
    fill: "#E6E5E5"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5001,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 60.5001 53.1667)",
    fill: "#E6E5E5"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5001,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 60.5001 45.8334)",
    fill: "#E6E5E5"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5001,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 60.5001 38.5)",
    fill: "#E6E5E5"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5001,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 60.5001 31.1667)",
    fill: "#E6E5E5"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5001,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 60.5001 23.8334)",
    fill: "#E6E5E5"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5001,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 60.5001 16.5)",
    fill: "#E6E5E5"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5001,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 60.5001 9.16667)",
    fill: "#E6E5E5"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5001,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 60.5001 1.83335)",
    fill: "#E6E5E5"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8333,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 67.8333 53.1667)",
    fill: "#E6E5E5"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8333,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 67.8333 45.8334)",
    fill: "#E6E5E5"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8333,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 67.8333 38.5)",
    fill: "#E6E5E5"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8333,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 67.8333 31.1667)",
    fill: "#E6E5E5"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8333,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 67.8333 23.8334)",
    fill: "#E6E5E5"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8333,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 67.8333 16.5)",
    fill: "#E6E5E5"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8333,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 67.8333 9.16667)",
    fill: "#E6E5E5"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.8333,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 67.8333 1.83335)",
    fill: "#E6E5E5"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1666,
    cy: 53.1667,
    r: 1.83333,
    transform: "rotate(-90 75.1666 53.1667)",
    fill: "#E6E5E5"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1666,
    cy: 45.8334,
    r: 1.83333,
    transform: "rotate(-90 75.1666 45.8334)",
    fill: "#E6E5E5"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1666,
    cy: 38.5,
    r: 1.83333,
    transform: "rotate(-90 75.1666 38.5)",
    fill: "#E6E5E5"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1666,
    cy: 31.1667,
    r: 1.83333,
    transform: "rotate(-90 75.1666 31.1667)",
    fill: "#E6E5E5"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1666,
    cy: 23.8334,
    r: 1.83333,
    transform: "rotate(-90 75.1666 23.8334)",
    fill: "#E6E5E5"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1666,
    cy: 16.5,
    r: 1.83333,
    transform: "rotate(-90 75.1666 16.5)",
    fill: "#E6E5E5"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1666,
    cy: 9.16667,
    r: 1.83333,
    transform: "rotate(-90 75.1666 9.16667)",
    fill: "#E6E5E5"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1666,
    cy: 1.83335,
    r: 1.83333,
    transform: "rotate(-90 75.1666 1.83335)",
    fill: "#E6E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.87b90528bb51e9fe383a1694cc063a16.svg";
export { ForwardRef as ReactComponent };